module.exports = __webpack_public_path__ + "static/media/administrator.4012c805.svg";